export default {
    name: 'TriangleLeft',
    dimensions: { width: 8, height: 11 },
    content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1.50001C7.5 1.1156 7.27965 0.765226 6.93319 0.598706C6.58672 0.432186 6.17548 0.479005 5.8753 0.719141L0.875305 4.71914C0.638089 4.90891 0.5 5.19623 0.5 5.50001C0.5 5.80379 0.638089 6.09111 0.875305 6.28088L5.8753 10.2809C6.17547 10.521 6.58672 10.5678 6.93319 10.4013C7.27965 10.2348 7.5 9.88441 7.5 9.50001L7.5 1.50001Z" fill="currentColor"/>
`
};
